export function GetCreditCardName(creditCardBrand: string) {
    let creditCardTypes = new Map();
    creditCardTypes.set('amex','American Express');
    creditCardTypes.set('American Express','American Express');
    creditCardTypes.set('mastercard','Mastercard');
    creditCardTypes.set('MasterCard','Mastercard');
    creditCardTypes.set('visa','Visa');
    creditCardTypes.set('Visa','Visa');

    let ccb = creditCardTypes.get(creditCardBrand);

    return (ccb === undefined || ccb === null) ? creditCardBrand : ccb;
}